import { atom } from 'jotai';

import type { UsersListSort } from '@/api/v4/user.api';
import type {
  APP_USER_ROLES,
  CompanyOption as BaseCompanyOption,
  IOption,
} from '@/types';
import type { ISort } from '@/ui/table/table.types';

import type { SettingsTabs } from './use-settings-tabs-config';

export const defaultSettingsAcitveTab = 'profileSettings';

export const settingsActiveTabState = atom<SettingsTabs>(
  defaultSettingsAcitveTab,
);

export const settingsUsersLoadingState = atom<boolean>(false);

export const settingsUsersSearchPhraseState = atom<string>('');

export const settingsUsersSortState = atom<ISort<UsersListSort>>({
  sort: 'status',
  direction: 'asc',
});

export const settingsInvitedUsersSearchPhraseState = atom<string>('');

export const settingsInvitedUsersSortState = atom<ISort<UsersListSort>>({
  sort: 'createdDate',
  direction: 'desc',
});

export type UserRoleOption = {
  label: APP_USER_ROLES;
  id: string;
};

type ProjectOption = IOption & { type: 'project' };
type OrganizationOption = BaseCompanyOption & { type: 'organization' };

export type EntityOption = ProjectOption | OrganizationOption;

type ChangeUserRolePayload = {
  userId: number;
  newRoleId: string;
  entities: Array<EntityOption>;
};

export const settingsChangeUserRoleFormState =
  atom<ChangeUserRolePayload | null>(null);
